import { createTransform } from 'redux-persist'

import type { ContratacaoState } from './index'

type ContratacaoPersistSlice = Pick<ContratacaoState, 'loadingContratacao'>

export const withoutPersistedContratacaoLoading = <T extends ContratacaoPersistSlice>(
  state: T,
): Omit<T, 'loadingContratacao'> & { loadingContratacao: false } => ({
  ...state,
  loadingContratacao: false,
})

export const contratacaoLoadingPersistTransform = createTransform<
  ContratacaoPersistSlice,
  ContratacaoPersistSlice
>(
  (inbound: ContratacaoPersistSlice) => withoutPersistedContratacaoLoading(inbound),
  (outbound: ContratacaoPersistSlice) => withoutPersistedContratacaoLoading(outbound),
  { whitelist: ['contratacao'] },
)
